import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomesFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.71 12.39a2 2 0 0 0-.34-.43l-6.84-6.39-1.46-1.37-.7-.66a2.01 2.01 0 0 0-2.74 0l-.17.16.44.41 1.03.96 5.8 5.43a3.6 3.6 0 0 1 .69.87 4 4 0 0 1 .5 1.23 4.5 4.5 0 0 1 .08.82V29h2a1.9 1.9 0 0 0 1.28-.48 1.7 1.7 0 0 0 .27-.27 2 2 0 0 0 .41-.85.6.6 0 0 0 .01-.14A1 1 0 0 0 30 27V13.42a2 2 0 0 0-.04-.41 2.2 2.2 0 0 0-.25-.62" />
    <path d="M23.71 12.39a2 2 0 0 0-.34-.43l-8.3-7.76-.7-.66a2.01 2.01 0 0 0-2.74 0l-9 8.42a1.9 1.9 0 0 0-.46.66 2 2 0 0 0-.17.8V27a1.8 1.8 0 0 0 .04.4 1.94 1.94 0 0 0 .55 1.01 1.8 1.8 0 0 0 .63.43A2 2 0 0 0 4 29h18a1.9 1.9 0 0 0 1.28-.48 1.7 1.7 0 0 0 .27-.27 2 2 0 0 0 .41-.85A4 4 0 0 0 24 27V13.42a2 2 0 0 0-.04-.41 2.2 2.2 0 0 0-.25-.62M17 27H9v-8a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z" />
  </svg>
);
const ForwardRef = forwardRef(IconHomesFilledSVG);
ForwardRef.displayName = "IconHomesFilled";
export { ForwardRef as IconHomesFilled };
